// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { css } from "styled-components";

export interface ShopByLookStyles {
    page?: MobiusPageProps;
}

export const shopByLookPageStyles: ShopByLookStyles = {};
const styles = shopByLookPageStyles;

const ShopByLookPage = ({ id }: PageProps) => (
    <StyledWrapper>
        <StyledWrapper
            css={css`
                margin: 0 auto;
            `}
        >
            <Zone zoneName="banner" contentId={id} />
        </StyledWrapper>
        <Page data-test-selector="shopByLookPage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
            <Modals />
        </Page>
    </StyledWrapper>
);

const pageModule: PageModule = {
    component: ShopByLookPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

export const ShopByLookContext = "ShopByLookPage";
